import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { keywordsActions, searchTableActions } from '../../actions'
import CrudHeader from '../../components/CrudHeader'
import Typography from '@material-ui/core/Typography'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class Keywords extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newKeyword, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Palavras-chave'}
          classes={classes}
          newResource={newKeyword}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'palavrasChave'}
        />
        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.keywords.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(keywordsActions.openModal())
    },
    closeModal: () => {
      dispatch(keywordsActions.closeModal())
    },
    newKeyword: keyword => {
      dispatch(keywordsActions.newFormKeyword(keyword))
    },
    resetState: () => {
      dispatch(keywordsActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Keywords))



// WEBPACK FOOTER //
// ./src/containers/Keywords/index.js